import { useNavigate } from 'react-router-dom';

import { useAccountStore } from '@/store';

import { Button } from '@/components/ui/button/Button';
import Header from '@/components/common/Header';

interface ErrorFallbackProps {
  error?: Error;
  componentStack?: string;
  resetError: () => void;
}

const ErrorFallback = ({ resetError }: ErrorFallbackProps) => {
  const { account } = useAccountStore();
  const navigate = useNavigate();

  const handleTryAgain = () => {
    if (!account || !account.default_project.id) {
      navigate('/login');
      resetError();
      return;
    }

    navigate(-1);
    resetError();
  };

  return (
    <section className='min-h-screen w-full flex flex-col'>
      <Header />

      <div className={'flex justify-center items-center relative'}>
        <div className='flex flex-col items-center gap-4'>
          <div className='flex flex-col items-center gap-8'>
            <div className='flex flex-col items-center gap-2'>
              <p className='font-semibold'>Oops, something went wrong...</p>
            </div>

            <Button variant={'yellow'} onClick={handleTryAgain}>
              Try again
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ErrorFallback;
